import { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  subtitle?: string;
  align?: 'left' | 'center';
  light?: boolean;
  className?: string;
}

const SectionHeading = ({ eyebrow, title, subtitle, align = 'left', light = false, className = '' }: SectionHeadingProps) => {
  const alignClass = align === 'center' ? 'text-center items-center mx-auto' : 'text-left items-start';
  const maxW = align === 'center' ? 'max-w-2xl' : 'max-w-xl';

  return (
    <div className={`flex flex-col ${alignClass} ${maxW} ${className}`}>
      {eyebrow && (
        <div className={`text-xs font-semibold uppercase tracking-[0.14em] mb-3 ${light ? 'text-gold-400' : 'text-primary-600'}`}>
          {eyebrow}
        </div>
      )}
      <h2 className={`text-3xl md:text-4xl font-serif font-medium leading-tight ${light ? 'text-white' : 'text-slate-900'}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base md:text-lg leading-relaxed ${light ? 'text-primary-200' : 'text-slate-600'}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
